import Phaser from "phaser";
import { SCALE, TICK_TIME, TILE_SIZE } from "../../utils/constants";

class CircularProgress {
  constructor(scene) {
    this.scene = scene;
    this.object = null;
    this.flash = null;
  }

  setValue(value) {
    this.object.value = value;
    if (this.object.value > 0.85) {
      this.flash.flash();
    }
  }

  reset() {
    this.scene.tweens.add({
      targets: this.object,
      value: 0,
      ease: "Linear",
      duration: 500,
    });
  }

  draw({
    x = 0,
    y = 0,
    radius = 0.5 * SCALE,
    barColor = 0x5d9b79,
    trackColor = 0x486859,
    centerColor = 0x486859,
    thickness = 0.8,
    startAngle = Phaser.Math.DegToRad(270),
  }) {
    this.object = this.scene.add.rexCircularProgress({
      x,
      y,
      radius,

      barColor,
      trackColor,
      centerColor,
      thickness,
      startAngle,
      anticlockwise: true,

      value: 0,
      easeValue: {
        duration: 0,
        ease: "Linear",
      },
      valuechangeCallback: function (newValue, oldValue, circularProgress) {
        // console.log(newValue, oldValue, circularProgress);
      },
    });
    this.object.setScrollFactor(0);
    this.object.depth = 100;
    this.object.name = "circularProgress";

    this.flash = this.scene.plugins
      .get("rexFlash")
      .add(this.object, { duration: TICK_TIME, repeat: 2 });
  }
}

export default CircularProgress;
